module.exports = __webpack_public_path__ + "img/PG2_1-3-258x195.99f339c9.png";